export default {
  title: 'Google Business',
  sections: {
    google_business_info: 'Informații Google Business',
    google_reviews: 'Recenzii Google',
    settings: 'Setări',
    danger_zone: 'Zonă periculoasă',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'Răspunsuri automate AI',
    },
    reviews_autopilot_daily_limit: {
      label: 'Limită zilnică răspunsuri automate AI (min 1, max 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Ore ce trebuie să treacă după scrierea recenziei',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Afișează toate recenziile',
      show_only_unanswered: 'Afișează doar cele fără răspuns',
    },
    rating_filter: {
      label: 'Filtru evaluare',
      stars_one: '{{count}} stea',
      stars_few: '{{count}} stele',
      stars_other: '{{count}} stele',
    },
    sorting: {
      newest_to_oldest: 'Sortează de la nou la vechi',
      oldest_to_newest: 'Sortează de la vechi la nou',
      rating_highest_to_lowest: 'Sortează de la cea mai mare la cea mai mică evaluare',
      rating_lowest_to_highest: 'Sortează de la cea mai mică la cea mai mare evaluare',
    },
  },
  table: {
    pagination: {
      total_one: 'Total {{count}} recenzie',
      total_few: 'Total {{count}} recenzii',
      total_other: 'Total {{count}} recenzii',
    },
  },
  modal_publish: {
    title: 'Sigur doriți să publicați pe Google?',
    buttons: {
      yes: 'Da',
      cancel: 'Anulare',
    },
  },
  popconfirm: {
    title: 'Ești sigur?',
    description: 'Toate modificările locale vor fi suprascrise',
  },
  disconnect_profile: {
    title: 'Deconectare profil',
    button: 'Continuă',
    popconfirm: {
      title: 'Ești sigur?',
      description:
        'Aceasta va deconecta complet acest profil Google din sistemul FoodAmigos, inclusiv înlocuirea automată a linkurilor și pilotul automat de răspunsuri la recenzii!',
    },
  },
  buttons: {
    login_with_google: 'Autentificare cu Google',
    sync_from_google: 'Obține versiunea actualizată',
    publish_to_google: 'Publică pe Google',
    previous: 'Anterior',
    next: 'Următor',
    save_settings: 'Salvare setări',
  },
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    failed_to_fetch_reviews: 'Preluarea recenziilor a eșuat',
    failed_to_fetch_settings: 'Preluarea setărilor a eșuat',
    failed_to_load_google_business: 'Încărcarea Google Business a eșuat',
    failed_to_publish_to_google_business: 'Publicarea pe Google Business a eșuat',
    publish_access_denied:
      'Google a refuzat actualizarea: contul Google conectat nu mai poate edita acest profil de companie. Verifică accesul în Google Business Profile sau reconectează-te cu contul care administrează restaurantul.',
    failed_to_fetch_info: 'Obținerea versiunii actualizate Google Business a eșuat',
    success_publish_to_google_business: 'Publicat cu succes pe Google Business',
    success_sync_from_google: 'Sincronizat cu succes din Google Business',
    success_save_settings: 'Setări salvate cu succes',
    failed_to_disconnect_profile: 'Deconectarea Google Business a eșuat, contactați echipa tehnică!',
    popup_blocked: 'Permiteți ferestrele pop-up pentru acest site pentru a conecta Google Business.',
    failed_to_connect: 'Google Business nu a putut fi conectat. Vă rugăm să încercați din nou.',
    no_business_profile:
      'Acest cont Google nu gestionează niciun profil de companie. Conectați-vă cu contul Google care gestionează restaurantul.',
  },
  callback: {
    connecting: 'Se conectează Google Business…',
    connected: 'Google Business este conectat. Puteți închide această fereastră.',
    cancelled: 'Conectarea a fost anulată. Puteți închide această fereastră.',
    failed: 'Google Business nu a putut fi conectat. Închideți această fereastră și încercați din nou.',
  },
  alerts: {
    no_profile: {
      title: 'Niciun Google Place conectat',
      description: 'Conectați restaurantul la un Google Place.',
      button: {
        connect: 'Conectare',
      },
    },
    unverified_location: {
      title: 'Google Business nu este verificat',
      description: 'Verificați-vă Google Business pentru a continua',
    },
  },
};
